import { Injectable } from '@angular/core';
import { Cliente } from '../persistences/cliente';
import { ClienteFilial } from '../persistences/cliente-filial';

@Injectable({
  providedIn: 'root'
})
export class ClienteSingletonService {

	public cliente: Cliente = new Cliente();
	public clienteFilial: ClienteFilial = new ClienteFilial();
	
	configuraService(cli: ClienteSingletonService){
		this.cliente = cli.cliente;
		this.clienteFilial = cli.clienteFilial;
		this.cliente.cdTipoEntrega = cli.cliente.cdTipoEntrega;
	}
}
